import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Medical extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Medical </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      Medical technology is changing faster than it ever has before, 
                      and it's now clear Augmented Reality and Virtual Reality will 
                      play a role in the standard care we receive.
                      The promise of the technologies is astounding. It won't be long 
                      before a nurse can read your diagnostics at a glance thanks to an 
                      AR headset. As research into mindfulness and the brain's ameliorative 
                      power advances, new VR applications will offer anesthesia-intolerant 
                      patients opportunities for pain-free surgeries.
                      But what usually gets lost in conversations about the promise of these 
                      technologies is the current generation of mixed reality applications 
                      that are in use in healthcare today.
                      <br></br>
                      <br></br>
                      AR and VR have already begun making inroads into surgical suites, medical 
                      training, doctor's offices, and home care situations. If you have a child 
                      with autism or you're training to be surgeon, there's a good chance you've 
                      already encountered them in some form.
                      
                      With that in mind, here are three AR/VR companies whose healthcare products are in use today.
                      
                      Immersive technologies such as virtual reality (VR) and augmented reality (AR) 
                      allow users to behave how they would in the real world, but in an artificial environment 
                      centred around the user through headsets, earphones, and other body sensors.
                      
                      However, both technologies couldn’t be more different. VR is the use of computer 
                      technology to create a simulated environment, while AR is an enhanced version of 
                      reality with the technology adding additional elements or images.
                      
                      Both technologies have the potential to create new applications that support the 
                      training of medical professionals and the delivery of health services and improve 
                      the health outcomes of NHS users. However, they also risk displacing workers in the 
                      health sector, including public servants in the NHS.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Virtual reality possibilities for clinical spaces</b>
                      <br></br>
                      What if here was anywhere? What if a hospital room was only a moment 
                      away from becoming a tropical beach, or a mentally stimulating game world? 
                      VR enables these possibilities — and more. VR headsets that are already on 
                      the market allow patients to have carefully crafted visual experiences that 
                      can suit a range of purposes. VR experiences can serve as adjunctive care with 
                      other treatment regimens, like programs that provide visuals for amputees or 
                      stroke patients in physical therapy. VR can also provide an alternative to some 
                      pharmaceutical interventions for psychiatric care, especially in the treatment 
                      of phobias, anxiety or even some personality disorders.
                      <br></br>
                      VR can even perform an analgesic function by distracting patients in pain, 
                      potentially lessening the need for heavy pain medication. One study from 2011 
                      explored how military burn victims dealt with the painful process of wound debridement 
                      with or without the use of a VR headset. Those who got to experience VR during the 
                      procedure reported significantly less pain. Since that study, VR has only become more 
                      immersive, which bodes well for the future of VR in pain relief. As VR hardware continues 
                      to become lighter and even more self-contained, where VR experiences take place will matter 
                      less and less.
                      <br></br>
                      What if being “at” a surgery was a matter of connectivity rather than of physical presence? 
                      That’s already happening, too. Thanks to VR technology, medical training and Continuing 
                      Medical Education (CME) software and equipment have seen the beginnings of a revolution. 
                      Rather than traveling across the world to witness a rare procedure being performed by an 
                      expert, surgeons can witness important surgeries in immersive VR. Clinicians who are in 
                      training or getting CME credit can practice new techniques without needing live patients.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Augmented reality for patient-centric care</b>
                      <br></br>
                      AR apps, wearables and mobile devices have shown tremendous potential 
                      in patient self-monitoring, diagnosis and patient care. AR technology 
                      layers over the real world, providing digital visuals, sounds or other 
                      stimuli that give insights from gathered data or add enhanced detail to 
                      reality. From contact lenses that give visual cues to diabetics when glucose 
                      levels fluctuate dangerously to smartwatches that use near-field communication 
                      to remind patients to take prescription medicine when it’s nearby, there are 
                      already technologies in development that help patients take control of their health using AR.
                      <br></br>
                      AR can also help healthcare providers untether themselves from fixed technologies 
                      that limit movement and provide interruptions in care. Relying on stationary terminals 
                      for inputting and viewing medical records doesn’t have to be the standard practice. 
                      AR glasses with gesture-based interfaces that display patient information give a hands-free, 
                      highly mobile opportunity to providers. Mobile technology that uses AR to assist with 
                      blood draws and diagnostic apps that use smartphone cameras to cross-reference visual 
                      symptoms against a database of categorized images are a couple of potential game-changers 
                      that already exist. While some therapeutic situations will probably always call for the 
                      resources and equipment of a dedicated medical facility, the possibility that a provider’s 
                      office might simply be wherever the provider is — if they have the proper gadgetry — is 
                      becoming more likely.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Where patient care and provider training happen is changing, with AR and VR devices 
                      at the forefront of this paradigm shift. As these technologies gain momentum, 
                      there will be no shortage of opportunities for innovators who want to enter the market. 
                      Whatever devices emerge, patients and providers stand to benefit.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                        Check out our ever expanding Medical Science templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Medical;



// WEBPACK FOOTER //
// ./src/views/Pages/Medical/Medical.js